import * as React from "react";
import { useInstantSearch } from "react-instantsearch";
import { getResultsByIndex } from "../../../../Algolia/utils/Algolia/utils/get-results-by-index.js";
import { SortBy } from "../../../../Algolia/components/SortBy/Algolia/components/SortBy/SortBy.js";
const SearchOrderBy = ({
  amountOfHitsLabel,
  showSortBy,
  activeIndex,
  sortIndices
}) => {
  const { scopedResults } = useInstantSearch();
  const suggestions = getResultsByIndex(scopedResults, activeIndex?.name || "");
  const amountOfHits = `${suggestions?.nbHits || 0} ${amountOfHitsLabel}`;
  if (!sortIndices.length || !sortIndices[0]) return null;
  return /* @__PURE__ */ React.createElement("div", { className: "search-page-header__sort-results" }, /* @__PURE__ */ React.createElement("div", { className: "search-page-header__amount-hits" }, amountOfHits), showSortBy && sortIndices && sortIndices.length > 0 && /* @__PURE__ */ React.createElement("div", { className: "search-page-header__sort-by" }, /* @__PURE__ */ React.createElement(SortBy, { items: sortIndices })));
};
export {
  SearchOrderBy,
  SearchOrderBy as default
};
//# sourceMappingURL=SearchOrderBy.js.map
